import React, { useState } from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import PencilCaseMobilePopup from "../../../../teacher/features/appletsWidget/mobileAppletsWidget/pencilCaseMobilePopup/PencilCaseMobilePopup";
import pencilCaseImg from "../../../../assests/classroomApplets/pencilCase.png";

const PencilCaseWidget = () => {
    
    const { texts } = useSelector(state => state.translate);
    const [pencilCasePopupOpen, setPencilCasePopupOpen] = useState(false);

    return (
        <>
            <WidgetCarouselCard
                color="#FAFAFA"
                title={texts.myPencilCase}
                image={pencilCaseImg}
                imageAlt={texts.myPencilCase}
                onClick={() => setPencilCasePopupOpen(true)}
            />
            {pencilCasePopupOpen &&
                <PencilCaseMobilePopup onClose={() => setPencilCasePopupOpen(false)} />
            }
        </>
    );
};

export default PencilCaseWidget;